var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"users f-c-b f-d-c w-100 h-100 p-4 pb-22 o-f-a"},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }